import { MFSection } from '../models/product/types';

export const MASTERFORMAT_SEARCH_PLACEHOLDER = 'Brand, product, MasterFormat';

interface MasterFormatFields {
    mfDivision?: MFSection;
    mfSection?: MFSection;
    mfSectionLevel1?: MFSection;
    mfSectionLevel2?: MFSection;
    mfSectionLevel3?: MFSection;
}

// Collapse all whitespace so a MasterFormat number typed without spaces
// ("0240") or with a shorthand ("1" for "01") still matches "02 40".
const stripSpaces = (value: string): string => value.replace(/\s+/g, '');

// Matches a search string against a product's MasterFormat division and section
// names as well as their numbers. Numbers are compared with whitespace removed so
// "0240" matches "02 40" and "1" matches "01" (and any number containing a 1).
export const matchesMasterFormatSearch = (
    product: MasterFormatFields,
    search: string | null | undefined,
): boolean => {
    if (!search) {
        return false;
    }
    const lowerSearch = search.toLowerCase();
    const searchDigits = stripSpaces(lowerSearch);

    const sections: Array<MFSection | undefined> = [
        product.mfDivision,
        product.mfSection,
        product.mfSectionLevel1,
        product.mfSectionLevel2,
        product.mfSectionLevel3,
    ];

    return sections.some((section) => {
        if (!section) {
            return false;
        }
        const label = section.label?.toLowerCase() ?? '';
        const numberDigits = stripSpaces((section.number ?? '').toLowerCase());
        return (
            label.includes(lowerSearch) ||
            (searchDigits.length > 0 && numberDigits.includes(searchDigits))
        );
    });
};
